<template>
  <div class="row">
    <div class="d-flex col-12 d-flex justify-content-between">
      <div class="document_type_name">
        <label class="titleComponent">{{ title }}</label>
      </div>
      <div class="text-right">
        <!-- <i class="iconSize" :class="statusIcon"></i> -->
        <svg v-if="statusIcon.includes('success')" width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9 0C4.02955 0 0 4.02934 0 9C0 13.9707 4.02955 18 9 18C13.9705 18 18 13.9707 18 9C18 4.02934 13.9705 0 9 0ZM9 16.3637C4.93323 16.3637 1.63636 13.0668 1.63636 9.00007C1.63636 4.9333 4.93323 1.63643 9 1.63643C13.0668 1.63643 16.3636 4.9333 16.3636 9.00007C16.3636 13.0668 13.0668 16.3637 9 16.3637ZM11.1737 6.78479C11.4932 6.4655 12.0113 6.4655 12.3308 6.78479C12.6507 7.1045 12.6503 7.62241 12.3306 7.94191L8.85948 11.413C8.53998 11.7325 8.02166 11.7325 7.70216 11.413L5.9668 9.67789C5.6473 9.35818 5.6473 8.84007 5.9668 8.52057C6.2865 8.20107 6.80441 8.20107 7.12391 8.52057L8.28102 9.67768L11.1737 6.78479Z" fill="#49A0A2"/>
        </svg>
        <svg v-else-if="statusIcon.includes('warning')" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M10.2025 10.1H1.80252C1.66252 10.1 1.53252 10.02 1.45252 9.89999C1.38252 9.77999 1.38252 9.62999 1.45252 9.49999L5.65252 2.09999C5.72253 1.96999 5.85252 1.89999 6.00252 1.89999C6.15252 1.89999 6.28253 1.97999 6.35253 2.09999L10.5525 9.49999C10.6225 9.61999 10.6225 9.77999 10.5525 9.89999C10.4725 10.02 10.3425 10.1 10.2025 10.1ZM2.49253 9.29999H9.52252L6.01252 3.10999L2.49253 9.29999ZM6.40252 6.90999V5.04999C6.40252 4.82999 6.22253 4.64999 6.00252 4.64999C5.78253 4.64999 5.60252 4.82999 5.60252 5.04999V6.90999C5.60252 7.12999 5.78253 7.30999 6.00252 7.30999C6.22253 7.30999 6.40252 7.12999 6.40252 6.90999ZM6.35253 8.56999C6.44252 8.47999 6.50252 8.34999 6.50252 8.21999C6.50252 8.08999 6.45253 7.95999 6.35253 7.86999C6.26253 7.77999 6.13252 7.71999 6.00252 7.71999C5.87252 7.71999 5.74253 7.76999 5.65252 7.86999C5.56252 7.95999 5.50252 8.08999 5.50252 8.21999C5.50252 8.34999 5.55253 8.47999 5.65252 8.56999C5.74253 8.65999 5.87252 8.71999 6.00252 8.71999C6.13252 8.71999 6.26253 8.65999 6.35253 8.56999Z" fill="#FF0000"/>
        </svg>
        <span class="styleStatus"
          :class="[statusIcon && statusIcon.includes('warning') ? 'font-weight-bold' : '']"
          :style="statusIcon && statusIcon.includes('warning') ? 'color:#ff0000' : ''">
          {{ statusLabel }}
        </span>
      </div>
    </div>
    <div class="d-flex col-12" v-if="!isSlotEmpty">
      <form-accordion-v2 :id="title" :title="subTitle" chevron-open="chevron_up" chevron-close="chevron_down"  class="styleSubTitle">
        <div class="documentInformation col-sm-12 col-sm-7 px-2 py-2">
          <slot></slot>
        </div>
      </form-accordion-v2>
    </div>
  </div>
</template>

<script>
import FormAccordionV2 from '@/components/common/FormAccordionV2.vue'

export default {
  name: 'documentTypeHeader',
  components: {
    'form-accordion-v2': FormAccordionV2
  },
  props: {
    statusIcon: {
      type: String,
      default: ''
    },
    statusLabel: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    isSlotEmpty () {
      return !this.$slots.default
    }
  }
}
</script>

<style>
.titleComponent {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 18px;
  color: #1B1918;
}
.styleSubTitle {
  color: #2E4057;
  font-weight: 400;
  line-height: 18px;
  font-size: 12px;
}
.styleStatus {
  font-size: 11px;
  line-height: 13px;
  color: #1B1918;
}
</style>
